import { useEffect, useRef, useState } from 'preact/hooks';
import { apiFetch } from '../api/client';

export function ReconnectSquare({ guided = false, label = 'Reconnect Square', cardStorage = false }) {
  const [connecting, setConnecting] = useState(false);
  const [error, setError] = useState('');
  const pending = useRef(false);
  const alive = useRef(false);
  useEffect(() => {
    alive.current = true;
    return () => { alive.current = false; };
  }, []);

  async function reconnect() {
    if (pending.current) return;
    pending.current = true;
    setConnecting(true);
    setError('');
    try {
      const result = await apiFetch('/account/dashboard', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: cardStorage ? 'make_card_oauth_url' : 'make_oauth_url' }),
      });
      const target = new URL(result?.oauth_url);
      if (!['https://connect.squareup.com', 'https://connect.squareupsandbox.com'].includes(target.origin)
          || target.pathname !== '/oauth2/authorize' || target.username || target.password) {
        throw new Error('The Square connection link could not be verified. Please try again.');
      }
      if (alive.current) window.location.assign(target.href);
    } catch (err) {
      pending.current = false;
      if (alive.current) {
        setError(err.message || 'Could not open Square. Please try again.');
        setConnecting(false);
      }
    }
  }

  return <div class={guided ? 'setup-connect' : undefined} style={{ marginTop: '1rem' }}>
    {!guided && <p style={{ margin: '0 0 0.5rem', fontSize: '0.8125rem', color: 'var(--text-secondary)' }}>Need to renew your Square connection? Sign in to the same Square business to reconnect.</p>}
    <button type="button" disabled={connecting} onClick={reconnect} style={{ minHeight: '44px', padding: '0.7rem 1rem', border: '1px solid var(--border-subtle)', borderRadius: '10px', background: 'white', color: 'var(--black)', font: 'inherit', cursor: 'pointer' }}>{connecting ? 'Opening Square…' : label}</button>
    {error && <p role="alert" style={{ color: 'var(--coral)', fontSize: '0.875rem', marginTop: '0.5rem' }}>{error}</p>}
  </div>;
}
